import React from "react";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

const GenerateImageEditorButtons = (props) => {
    const { handleGenerateClick, handleCloseModal, shouldDisableButtons } = props;
    return (
        <React.Fragment>
            <ActionButton onClick={handleCloseModal} variant="outlined">
                Cancel
            </ActionButton>
            <ActionButton
                onClick={handleGenerateClick}
                variant="contained"
                color="primary"
                disabled={shouldDisableButtons}
            >
                Generate
            </ActionButton>
        </React.Fragment>
    );
};

const ActionButton = styled(Button)(() => ({
    padding: "7px 16px",
}));
  

export default GenerateImageEditorButtons;
